module.exports = __webpack_public_path__ + "static/media/stedman-for-senate-bust.7f065e6d.png";